module.exports = __webpack_public_path__ + "static/fonts/iconfont.fba16bb.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/alfont/iconfont.woff2?t=1697420656926
// module id = tQts
// module chunks = 84